export const LegalHero = ({ title, eyebrow = 'LEGAL' }) => (
  <section className="px-6 lg:px-12 pt-36 lg:pt-48 pb-14" style={{ background: 'radial-gradient(50% 60% at 90% 0%, rgba(200,170,115,0.06), transparent 70%)' }}>
    <div className="max-w-[1100px] mx-auto">
      <p className="eyebrow rise-in">{eyebrow}</p>
      <h1 className="display-xl mt-8 text-[clamp(2.1rem,6.4vw,6rem)] break-words hyphens-auto rise-in" style={{ animationDelay: '0.1s' }} data-testid="legal-title">{title}</h1>
      <div className="mt-14 h-px bg-[#F4F0E8]/10" />
    </div>
  </section>
);
